module.exports = __webpack_public_path__ + "static/media/mobileViewBack@3x.f7cf1250.png";